/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Character reversal works on whole Unicode code points, so emoji and accented letters stay intact instead of breaking into garbled pieces.`)
};

const es_rv_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. La inversión de caracteres funciona con puntos de código Unicode completos, por lo que los emoji y las letras acentuadas permanecen intactas en lugar de romperse en fragmentos ilegibles.`)
};

const de_rv_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Die Zeichenumkehrung arbeitet mit vollständigen Unicode-Codepunkten, sodass Emojis und Buchstaben mit Akzenten intakt bleiben, anstatt in unleserliche Fragmente zu zerfallen.`)
};

const nl_rv_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Tekens omkering werkt met hele Unicode-codepunten, dus emoji en geaccentueerde letters blijven intact in plaats van in verminkte stukken te breken.`)
};

const fr_rv_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. L'inversion de caractères fonctionne sur des points de code Unicode complets, donc les emoji et les lettres accentuées restent intacts au lieu de se diviser en morceaux brouillés.`)
};

const it_rv_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. L'inversione dei caratteri funziona su interi punti di codice Unicode, quindi emoji e lettere accentate rimangono intatte invece di rompersi in frammenti illeggibili.`)
};

const pt_br2_rv_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A inversão de caracteres funciona em pontos de código Unicode completos, portanto emojis e letras acentuadas permanecem intactos em vez de se quebrarem em fragmentos confusos.`)
};

const pt_rv_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A inversão de caracteres funciona em pontos de código Unicode completos, então emoji e letras acentuadas permanecem intactos em vez de se quebrarem em pedaços ilegíveis.`)
};

const ja_rv_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。文字反転は全体のUnicodeコードポイントで機能するため、絵文字とアクセント付き文字は、ガベージに分割されるのではなく、そのままの状態で残ります。`)
};

const zh_rv_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。字符反转基于完整的 Unicode 码点运作，因此表情符号和带重音符号的字母都能保持完整，不会变成乱码碎片。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_faq1_a", locale)
	if (locale === "en") return en_rv_faq1_a(inputs)
	if (locale === "es") return es_rv_faq1_a(inputs)
	if (locale === "de") return de_rv_faq1_a(inputs)
	if (locale === "nl") return nl_rv_faq1_a(inputs)
	if (locale === "fr") return fr_rv_faq1_a(inputs)
	if (locale === "it") return it_rv_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_rv_faq1_a(inputs)
	if (locale === "pt") return pt_rv_faq1_a(inputs)
	if (locale === "ja") return ja_rv_faq1_a(inputs)
	return zh_rv_faq1_a(inputs)
};